"use strict";

var _defineProperty = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/defineProperty");

var _default2;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.phaseEnum = void 0;

require("source-map-support/register");

var _phase = _interopRequireDefault(require("../phase"));

var _loadPlugins = _interopRequireDefault(require("./loadPlugins"));

var _loadCommands = _interopRequireDefault(require("./loadCommands"));

var _listen = _interopRequireDefault(require("./listen"));

var _process = _interopRequireDefault(require("./process"));

var _execute = _interopRequireDefault(require("./execute"));

var _respond = _interopRequireDefault(require("./respond"));

var phaseEnum = {
  LOAD_PLUGINS: 'loadPlugins',
  LOAD_COMMANDS: 'loadCommands',
  LISTEN: 'listen',
  PROCESS: 'process',
  EXECUTE: 'execute',
  RESPOND: 'respond'
};
exports.phaseEnum = phaseEnum;

var _default = (_default2 = {}, _defineProperty(_default2, phaseEnum.LOAD_PLUGINS, (0, _phase.default)(_loadPlugins.default)), _defineProperty(_default2, phaseEnum.LOAD_COMMANDS, (0, _phase.default)(_loadCommands.default)), _defineProperty(_default2, phaseEnum.LISTEN, (0, _phase.default)(_listen.default)), _defineProperty(_default2, phaseEnum.PROCESS, (0, _phase.default)(_process.default)), _defineProperty(_default2, phaseEnum.EXECUTE, (0, _phase.default)(_execute.default)), _defineProperty(_default2, phaseEnum.RESPOND, (0, _phase.default)(_respond.default)), _default2);

exports.default = _default;